export default "__VITE_ASSET__C9ti2$HH__"